import { Outlet } from 'react-router-dom'
import { makeStyles } from '@material-ui/core/styles'

import PromptInputArea from './chat-panel/prompt-area'

import ConversationHistory from './chat-panel/conversation-history'

import useConversationsStore from '@/stores/useConversationsStore'
import useCurrentChatId from '@/components/hooks/use-current-chat-id'
import { DragDropProvider } from '../context/drag-and-drop.context'

const useStyles = makeStyles((theme) => ({
  container: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  mainArea: {
    flex: 1,
    minWidth: 0,
    padding: `${theme.spacing(0)}px ${theme.spacing(4)}px`,
    overflowY: 'auto',
  },
}))

const ChatPanel = () => {
  const classes = useStyles()
  const chatId = useCurrentChatId()

  const pendingMessage = useConversationsStore((state) => state.pendingFirstMessage)

  return (
    <DragDropProvider>
      <div className={classes.container}>
        <div className={classes.mainArea}>
          {pendingMessage && !chatId ? (
            <ConversationHistory pendingMessage={pendingMessage} />
          ) : (
            <Outlet />
          )}
        </div>
        <PromptInputArea />
      </div>
    </DragDropProvider>
  )
}

export default ChatPanel
